module.exports = __webpack_public_path__ + "img/P16.899d7d45.png";